import Lookup from 'src/componentes/select2';

const ConfirmacaoReuniaoLookup = (props) => {
  return (
    <Lookup
      clearable={false}
      labelKey="descricao"
      valueKey="id"
      url="/ConfirmacaoReuniaoLookup"
      {...props}
    />
  );
};

export default ConfirmacaoReuniaoLookup;
